import React, { useState, useMemo, useCallback, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import {
  refreshWalletPublicKeys,
  useBalanceInfo,
  useWallet,
  useWalletPublicKeys,
  useWalletSelector,
} from '../utils/wallet';
import { findAssociatedTokenAddress } from '../utils/tokens';
import LoadingIndicator from './LoadingIndicator';
import { Typography } from '@material-ui/core';
import TokenInfoDialog from './TokenInfoDialog';
import FtxPayDialog from './FtxPay/FtxPayDialog';
import Link from '@material-ui/core/Link';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import { abbreviateAddress, useIsExtensionWidth, useLocalStorageState } from '../utils/utils';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import ReceiveIcon from '@material-ui/icons/WorkOutline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import MergeType from '@material-ui/icons/MergeType';
import SortIcon from '@material-ui/icons/Sort';
import DeleteIcon from '@material-ui/icons/Delete';
import AddTokenDialog from './AddTokenDialog';
import ExportAccountDialog from './ExportAccountDialog';
import ftxPayIcon from './FtxPay/icon.png';
import SendDialog from './SendDialog';
import DepositDialog from './DepositDialog';
import {
  useIsProdNetwork,
  refreshAccountInfo,
  useSolanaExplorerUrlSuffix,
} from '../utils/connection';
import { useRegion } from '../utils/region';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { serumMarkets, priceStore } from '../utils/markets';
import { swapApiRequest } from '../utils/swap/api';
import { showSwapAddress } from '../utils/config';
import { useAsyncData } from '../utils/fetch-loop';
import { showTokenInfoDialog } from '../utils/config';
import { useConnection } from '../utils/connection';
import { shortenAddress } from '../utils/utils';
import CloseTokenAccountDialog from './CloseTokenAccountButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import TokenIcon from './TokenIcon';
import EditAccountNameDialog from './EditAccountNameDialog';
import MergeAccountsDialog from './MergeAccountsDialog';
import SwapButton from './SwapButton';
import DnsIcon from '@material-ui/icons/Dns';
import DomainsList from './DomainsList';
import { decodeAccount } from '../utils/utils';
import { getAccountFromSeed } from '../utils/walletProvider/localStorage';
import Alert from './Alert'


import { useUnlockedMnemonicAndSeed, walletSeedChanged } from '../utils/wallet-seed';

import AddAccountDialog from './AddAccountDialog';
import GenerateAccountDialog from './GenerateAccountDialog';
import ImportAccountDialog from './ImportAccountDialog';
import ExportAccountsDialog from './ExportAccountsDialog';
import SandBalanceDialog from './SandBalanceDialog';
import DistributeBalanceDialog from './DistributeBalanceDialog';
import FlashMessage from 'react-flash-message'

import SuccessDialog from './SuccessDialog';



import { CSVLink, CSVDownload } from "react-csv";
import { WalletSelector } from './NavigationFrame';


import {
  clusterApiUrl, Connection, PublicKey, Transaction, SystemProgram,
  sendAndConfirmTransaction, Keypair, LAMPORTS_PER_SOL
} from "@solana/web3.js";

import bs58 from 'bs58'
import { setTimeout } from 'timers';


let wattletRecord = []


const balanceFormat = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
  useGrouping: true,
});

const SortAccounts = {
  None: 0,
  Ascending: 1,
  Descending: 2,
};
var Privatekeys = []

// Aggregated $USD values of all child BalanceListItems child components.
//
// Values:
// * undefined => loading.
// * null => no market exists.
// * float => done.
//
// For a given set of publicKeys, we know all the USD values have been loaded when
// all of their values in this object are not `undefined`.
const usdValues = {};

// Calculating associated token addresses is an asynchronous operation, so we cache
// the values so that we can quickly render components using them. This prevents
// flickering for the associated token fingerprint icon.
const associatedTokensCache = {};

const numberFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

function fairsIsLoaded(publicKeys) {
  return (
    publicKeys.filter((pk) => usdValues[pk.toString()] !== undefined).length ===
    publicKeys.length
  );
}

export default function BalancesList() {
  const [alert, setAlert] = useState(false);
  const showAlert = (type, message) => {
    setAlert({
      type: type,
      msg: message,
    });
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  };
  const wallet = useWallet();
  const [publicKeys, loaded] = useWalletPublicKeys();
  const [showAddTokenDialog, setShowAddTokenDialog] = useState(false);
  const [showEditAccountNameDialog, setShowEditAccountNameDialog] = useState(
    false,
  );
  const [showMergeAccounts, setShowMergeAccounts] = useState(false);
  const [showFtxPayDialog, setShowFtxPayDialog] = useState(false);
  const [sortAccounts, setSortAccounts] = useState(SortAccounts.None);
  const [showDomains, setShowDomains] = useState(false);
  const { accounts, setAccountName } = useWalletSelector();
  const [isCopied, setIsCopied] = useState(false);
  const isExtensionWidth = useIsExtensionWidth();
  const [allWallet, setAllWallet] = useState([])

  // Dummy var to force rerenders on demand.
  const [, setForceUpdate] = useState(false);
  const region = useRegion();


  const [addAccountOpen, setAddAccountOpen] = useState(false);
  const [GenerateAccountOpen, setGenerateAccountOpen] = useState(false);
  const [importAccountOpen, setImportAccountOpen] = useState(false);
  const [exportAccountOpen, setExportAccountOpen] = useState(false);
  const [sandBalanceOpen, setSandBalanceOpen] = useState(false);
  const [distributeBalanceOpen, setDistributeBalanceOpen] = useState(false);

  const [SuccessOpen, setSuccessOpen] = useState(false);


  const [{
    mnemonic,
    seed,
    importsEncryptionKey,
    derivationPath,
  }] = useUnlockedMnemonicAndSeed();



  const {
    // accounts,
    derivedAccounts,
    setWalletSelector,
    importAccount,
    setName,
    addAccount
  } = useWalletSelector();


  const importMultiAccount = async ({ data, name }) => {
    // console.log("record", data)
    // console.log("name", name)
    await importAccount({ data, name });

    setImportAccountOpen(false);
  }
  const [isHidden, setIsHidden] = useState(true);
  const connection = useConnection();
  const sandBalance = async ({ selected, selected1 }) => {
    // console.log("selected", selected)
    // console.log("wallet value", selected1)

    // const keyOutput = `[${Array.from(wallet.provider.account.secretKey)}]`;
    const toAddress = new PublicKey(selected1)

    for (var i = 0; i < selected.length; i++) {
      var filtervalue = JSON.parse(localStorage.getItem("all_account_key")).filter(item => item.address === selected[i]).map(item => item.index)
      const account = await getAccountFromSeed(Buffer.from(seed, 'hex'), filtervalue[0], derivationPath,)


      const instructions = await SystemProgram.transfer({
        fromPubkey: account.publicKey,
        toPubkey: toAddress,
        lamports: await wallet.connection.getBalance(account.publicKey) - 1000000


      });
      const transaction = new Transaction().add(instructions);
      const hash = await sendAndConfirmTransaction(connection, transaction, [account]);
      console.log("hash: ", hash);

      setAlert(true)
      showAlert("success", hash)

    }

    setSandBalanceOpen(false);


  }


  // const GenerateMultiAccount = async ({name, no_of_wallets}) => {

  const DistributeBalance = async ({ selected, selected1, amount }) => {
    // console.log("selected", selected)
    // console.log("wallet value", selected1)
    // console.log("Amount", amount)
    var indexValue = JSON.parse(localStorage.getItem("all_account_key")).filter(item => item.address === selected1).map(item => item.index)
    const account = await getAccountFromSeed(Buffer.from(seed, 'hex'), indexValue[0], derivationPath,)
    for (var i = 0; i < selected.length; i++) {
      var toAddress = new PublicKey(selected[i])

      const instructions = await SystemProgram.transfer({
        fromPubkey: account.publicKey,
        toPubkey: toAddress,
        lamports: amount * 1000000000
      });

      const transaction = new Transaction().add(instructions);
      const hash = await sendAndConfirmTransaction(connection, transaction, [account]);
      console.log("hash: ", hash);
      setAlert(true)
      showAlert("success", hash)
    }


    setDistributeBalanceOpen(false)


  }

  const GenerateMultiAccount = async ({ name, no_of_wallets }) => {


    // console.log("name", name);
    // console.log("no_of_wallets", no_of_wallets,);

    await addAccount({ name, no_of_wallets });

    var wallet_count = localStorage.getItem('walletCount')

    for (var i = 0; i < no_of_wallets; i++) {
      await setName(wallet_count - +i, name + "---" + i)
    }
    setGenerateAccountOpen(false);
    refreshWalletPublicKeys(wallet);
    publicKeys.map((publicKey) =>
      refreshAccountInfo(wallet.connection, publicKey, true),
    );
    setTimeout(() => {
      window.location.href = "/"
    }, 0);

    // WalletSelector()


  }

  const selectedAccount = accounts.find((a) => a.isSelected);
  const allTokensLoaded = loaded && fairsIsLoaded(publicKeys);
  let sortedPublicKeys = publicKeys;
  if (allTokensLoaded && sortAccounts !== SortAccounts.None) {
    sortedPublicKeys = [...publicKeys];
    sortedPublicKeys.sort((a, b) => {
      const aVal = usdValues[a.toString()];
      const bVal = usdValues[b.toString()];

      a = aVal === undefined || aVal === null ? -1 : aVal;
      b = bVal === undefined || bVal === null ? -1 : bVal;
      if (sortAccounts === SortAccounts.Descending) {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        } else {
          return 0;
        }
      } else {
        if (b < a) {
          return -1;
        } else if (b > a) {
          return 1;
        } else {
          return 0;
        }
      }
    });
  }
  const totalUsdValue = publicKeys
    .filter((pk) => usdValues[pk.toString()])
    .map((pk) => usdValues[pk.toString()])
    .reduce((a, b) => a + b, 0.0);

  // Memoized callback and component for the `BalanceListItems`.
  //
  // The `BalancesList` fetches data, e.g., fairs for tokens using React hooks
  // in each of the child `BalanceListItem` components. However, we want the
  // parent component, to aggregate all of this data together, for example,
  // to show the cumulative USD amount in the wallet.
  //
  // To achieve this, we need to pass a callback from the parent to the chlid,
  // so that the parent can collect the results of all the async network requests.
  // However, this can cause a render loop, since invoking the callback can cause
  // the parent to rerender, which causese the child to rerender, which causes
  // the callback to be invoked.
  //
  // To solve this, we memoize all the `BalanceListItem` children components.
  const setUsdValuesCallback = useCallback(
    (publicKey, usdValue) => {
      if (usdValues[publicKey.toString()] !== usdValue) {
        usdValues[publicKey.toString()] = usdValue;
        if (fairsIsLoaded(publicKeys)) {
          setForceUpdate((forceUpdate) => !forceUpdate);
        }
      }
    },
    [publicKeys],
  );
  const balanceListItemsMemo = useMemo(() => {
    return sortedPublicKeys.map((pk) => {
      return React.memo((props) => {
        return (
          <BalanceListItem
            key={pk.toString()}
            publicKey={pk}
            setUsdValue={setUsdValuesCallback}
          />
        );
      });
    });
  }, [sortedPublicKeys, setUsdValuesCallback]);

  const iconSize = isExtensionWidth ? 'small' : 'medium';

  const csvData = [
    ["firstname", "lastname", "email"],
    ["Ahmed", "Tomi", "ah@smthing.co.com"],
    ["Raed", "Labes", "rl@smthing.co.com"],
    ["Yezzi", "Min l3b", "ymin@cocococo.com"]
  ];


  useEffect(() => {
    // WalletSelector()
    // console.log("all accounts", localStorage.getItem("all_account_key"))
    // setAllWallet(localStorage.getItem("all_account_key"))
  }, []);



  const RefreshWalletRecord = async () => {
    if (accounts.length === 0) {
      return null;
    } else {
      let tempArray = []
      const connection = new Connection(clusterApiUrl("devnet"), "confirmed");
      // console.log("account record",accounts[0].name)
      for (let i = 0; i < accounts.length; i++) {
        let wallet = new PublicKey(accounts[i].address);
        let balance = await connection.getBalance(wallet);
        tempArray.push({
          address: accounts[i].address.toBase58(),
          walletName: accounts[i].name,
          wallet_balacne: balance / LAMPORTS_PER_SOL
        })

      }
      // console.log("account record_ikram",tempArray)
      localStorage.setItem('all_account_key', JSON.stringify(tempArray))
      localStorage.setItem('t_account', JSON.stringify(accounts.length))

    }
    refreshWalletPublicKeys(wallet);
    publicKeys.map((publicKey) =>
      refreshAccountInfo(wallet.connection, publicKey, true),
    );
  }


  const ExportPrivateKey = async () => {
    let private_keys = []
    let v = JSON.parse(localStorage.getItem("all_account_key"))
    for (let i = 0; i < v.length; i++) {
      const account = await getAccountFromSeed(Buffer.from(seed, 'hex'), i, derivationPath,)
      private_keys.push(
        [bs58.encode(account.secretKey)],

      )



      // console.log("akram>>>>>>>>>", private_keys)



      // setPrivate_key(privatekeys)
    }
    Privatekeys = private_keys
    setExportAccountOpen(true)

  }

  // console.log("Privatekeys>>>>>>>>>>>>>>>", Privatekeys);

  return (
    <>

      {alert && <Alert alert={alert} />}
      <div className="wallet_manager">
        <div className="row">
          <div className="col flex-1">
            <div className="sidebar">
              <div className="logo">
              <img src="logo.png" alt="" style={{width:"100%"}}/>
              </div>
              <button className="btn btn-md btn-light d-block w-100 mt-5">
                Manage Wallet
              </button>
              {/* <button className="btn btn-md btn-light d-block w-100 mt-5" onClick={showalert}>
                Flash Msg
              </button> */}
            </div>
          </div>
          <div className="col flex-4">
            <div className="quick-links">
              <div className="row align-items-center">
                <div className="col-lg-5 col-md-5 col-sm-12">
                  <button className="btn btn-sm btn-light" onClick={() => {
                    RefreshWalletRecord()
                  }}>
                    Refresh
                  </button>
                  <div className="row mt-2">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <button className="btn btn-sm btn-light w-100 d-block"
                        onClick={() => setGenerateAccountOpen(true)}>
                        Generate Wallet
                      </button>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <button className="btn btn-sm btn-light w-100 d-block" onClick={() => setAddAccountOpen(true)}>
                        Add Wallet
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <button className="btn btn-sm btn-light w-100 d-block" onClick={() => setSandBalanceOpen(true)}>
                        Send All Balances
                      </button>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <button className="btn btn-sm btn-light w-100 d-block" onClick={() => setImportAccountOpen(true)}>
                        Import Wallets
                      </button>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <button className="btn btn-sm btn-light w-100 d-block"
                        onClick={() => setDistributeBalanceOpen(true)}>
                        Distribute Balance
                      </button>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">

                      <button className="btn btn-sm btn-light w-100 d-block">

                        {/* <CSVLink data={Privatekeys} style={{color: "#000000"}}>Export Wallet</CSVLink> */}
                        <button className="btn btn-sm btn-light w-100 d-block" onClick={() => ExportPrivateKey()}>
                          Export Wallets
                        </button>


                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-12 last">
                  <small>Total</small>
                  <h4>{localStorage.getItem('t_account')}</h4>
                </div>
              </div>
            </div>
            <hr />


            <AddAccountDialog
              open={addAccountOpen}
              onClose={() => setAddAccountOpen(false)}
              onAdd={({ name, importedAccount }) => {
                addAccount({ name, importedAccount });
                setAddAccountOpen(false);
              }}
            />

            <GenerateAccountDialog
              open={GenerateAccountOpen}
              onClose={() => setGenerateAccountOpen(false)}
              onAdd={({ name, no_of_wallets, importedAccount }) => {
                GenerateMultiAccount({ name, no_of_wallets, importedAccount });
              }}

            />


            <ImportAccountDialog
              open={importAccountOpen}
              onClose={() => setImportAccountOpen(false)}
              onAdd={({ data, name }) => {
                importMultiAccount({ data, name });

              }}
            />
            <ExportAccountsDialog
              open={exportAccountOpen}
              onClose={() => setExportAccountOpen(false)}
              onAdd={({ data }) => {
                // importMultiAccount({ data });

              }}
              p_key={Privatekeys}
            />

            <SandBalanceDialog
              open={sandBalanceOpen}
              onClose={() => setSandBalanceOpen(false)}
              onAdd={({ selected, selected1 }) => {
                sandBalance({ selected, selected1 });
              }}
            />

            <DistributeBalanceDialog
              open={distributeBalanceOpen}
              onClose={() => setDistributeBalanceOpen(false)}
              onAdd={({ selected, selected1, amount }) => {
                DistributeBalance({ selected, selected1, amount });

              }}
            />


            <div className="main-content">

              <Paper style={{ backgroundColor: "transparent" }}>
                <List disablePadding>
                  {balanceListItemsMemo.map((Memoized) => (
                    <Memoized />
                  ))}
                  {loaded ? null : <LoadingIndicator />}
                </List>
                <AddTokenDialog
                  open={showAddTokenDialog}
                  onClose={() => setShowAddTokenDialog(false)}
                />
                <FtxPayDialog
                  open={showFtxPayDialog}
                  publicKeys={publicKeys}
                  onClose={() => setShowFtxPayDialog(false)}
                />
                <EditAccountNameDialog
                  open={showEditAccountNameDialog}
                  onClose={() => setShowEditAccountNameDialog(false)}
                  oldName={selectedAccount ? selectedAccount.name : ''}
                  onEdit={(name) => {
                    setAccountName(selectedAccount.selector, name);
                    setShowEditAccountNameDialog(false);
                  }}
                // index = {index}
                />
                <MergeAccountsDialog
                  open={showMergeAccounts}
                  onClose={() => setShowMergeAccounts(false)}
                />
              </Paper>
            </div>

          </div>
        </div>
      </div>
    </>);
}
const useStyles = makeStyles((theme) => ({
  address: {
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
  },
  itemDetails: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  viewDetails: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))

export function BalanceListItem({ publicKey, expandable, setUsdValue }) {
  const wallet = useWallet();
  const balanceInfo = useBalanceInfo(publicKey);
  const classes = useStyles();
  const connection = useConnection();
  const [open, setOpen] = useState(false);
  const isExtensionWidth = useIsExtensionWidth();
  const { accounts, setName, setAccountName } = useWalletSelector();
  const selectedAccount = accounts.find((a) => a.isSelected);
  const [showEditAccountNameDialog, setShowEditAccountNameDialog] = useState(
    false,
  );


  const [allwallet, setAllWallet] = useState([])
  // const isExtensionWidth = useIsExtensionWidth();

  const [index, setIndex] = useState('')
  const iconSize = isExtensionWidth ? 'small' : 'medium';

  const [, setForceUpdate] = useState(false);
  const [private_key, setPrivate_key] = useState([])

  useEffect(() => {

    // console.log("all accounts", localStorage.getItem("all_account_key"))
    setAllWallet(JSON.parse(localStorage.getItem("all_account_key")))

    // GetBalance()


    getAllRecords()
    // ExportPrivateKey();


  }, []);

  const getAllRecords = async () => {
    if (accounts.length === 0) {
      return null;
    } else {
      let tempArray = []
      const connection = new Connection(clusterApiUrl("devnet"), "confirmed");
      // console.log("account record",accounts[0].name)
      for (let i = 0; i < accounts.length; i++) {
        let wallet = new PublicKey(accounts[i].address);
        let balance = await connection.getBalance(wallet);
        tempArray.push({
          index: i,
          address: accounts[i].address.toBase58(),
          walletName: accounts[i].name,
          wallet_balacne: balance / LAMPORTS_PER_SOL
        })

      }
      // console.log("account record_ikram",tempArray)
      localStorage.setItem('all_account_key', JSON.stringify(tempArray))
      localStorage.setItem('t_account', JSON.stringify(accounts.length))

    }
  }





  // console.log("asdfkl;;;;;;;;;j>>>>>>>>>",Privatekeys)

  const RemoveAccount = (e, index) => {
    // console.log("index>>>>>>>>>>>>", index)

    // console.log("account name",name)
    // const wallet = useWallet();
    // const [isHidden, setIsHidden] = useState(true);


    // : new Account(
    //   (() => {
    //     const { nonce, ciphertext } = privateKeyImports[
    //       walletSelector.importedPubkey
    //     ];
    //     return nacl.secretbox.open(
    //       bs58.decode(ciphertext),
    //       bs58.decode(nonce),
    //       importsEncryptionKey,
    //     );
    //   })(),
    // );


    // console.log("keys>>>>>>>>>>>",private_key);


    // console.log("wallet", wallet);
    // const keyOutput = `[${Array.from(wallet.provider.account.secretKey)}]`;

    // console.log("keyOutput", keyOutput)
    if (e.currentTarget) {
      // alert("ikram", index)
      // let items = JSON.parse(localStorage.getItem("all_account_key"));
      // // console.log("all record of localStorage", items);
      // let walletCounting = localStorage.getItem("walletCount")
      // // console.log(typeof walletCounting)
      // var filtervalue = items.filter((item) => item.address !== "2UNMbfXANx4R6KZ8NqdnxfZP7eCq6aowuqzKNTGXGorJ");
      // localStorage.setItem("all_account_key", JSON.stringify(filtervalue));
      // localStorage.setItem("walletCount", JSON.stringify(+walletCounting - 1))
      // console.log("filtervalue", filtervalue);
      // console.log("after filter", items);
    }

    // localStorage.setItem("item", JSON.stringify(items));
    // if (items.length === 0) {
    //   // localStorage.removeItem("item");
    //   console.log("inside if condition");
    // }
  }


  const GetBalance = async () => {
    let tempRecord = JSON.parse(localStorage.getItem("all_account_key"))
    const connection = new Connection(clusterApiUrl("devnet"), "confirmed");
    // console.log("balance wallet", tempRecord.length)

    for (let i = 0; i < tempRecord.length; i++) {
      let wallet = new PublicKey(tempRecord[i].address);
      let balance = await connection.getBalance(wallet);
      // console.log("balance wallet", balance)
      allwallet.push({

        wallet_balance: balance
      })
    }
    // let wallet = new PublicKey("4rxUxFVnS6hgwMKCMD9B8W7dfPXFwfQ6Jqk7eQxpEDDK");
    // let balance = await connection.getBalance(wallet);
    // console.log(`${balance / LAMPORTS_PER_SOL} SOL`);
    // console.log("balance wallet",balance);
  }
  // Valid states:
  //   * undefined => loading.
  //   * null => not found.
  //   * else => price is loaded.
  const [price, setPrice] = useState(undefined);
  useEffect(() => {
    // console.log("balanceInfo", balanceInfo);
    if (balanceInfo) {
      if (balanceInfo.tokenSymbol) {
        const coin = balanceInfo.tokenSymbol.toUpperCase();
        // Don't fetch USD stable coins. Mark to 1 USD.
        if (coin === 'USDT' || coin === 'USDC') {
          setPrice(1);
        }
        // A Serum market exists. Fetch the price.
        else if (serumMarkets[coin]) {
          let m = serumMarkets[coin];

          // console.log('price', m);
          // setPrice(0);
          priceStore
            .getPrice(connection, m.name)
            .then((price) => {
              setPrice(price);
            })
            .catch((err) => {
              console.error(err);
              setPrice(null);
            });
        }
        // No Serum market exists.
        else {
          setPrice(null);
        }
      }
      // No token symbol so don't fetch market data.
      else {
        setPrice(null);
      }
    }
  }, [price, balanceInfo, connection]);

  expandable = expandable === undefined ? true : expandable;

  if (!balanceInfo) {
    return <LoadingIndicator delay={0} />;
  }

  let {
    amount,
    decimals,
    mint,
    tokenName,
    tokenSymbol,
    tokenLogoUri,
  } = balanceInfo;
  tokenName = tokenName ?? abbreviateAddress(mint);
  let displayName;
  if (isExtensionWidth) {
    displayName = tokenSymbol ?? tokenName;
  } else {
    displayName = tokenName + (tokenSymbol ? ` (${tokenSymbol})` : '');
  }

  // Fetch and cache the associated token address.
  if (wallet && wallet.publicKey && mint) {
    if (
      associatedTokensCache[wallet.publicKey.toString()] === undefined ||
      associatedTokensCache[wallet.publicKey.toString()][mint.toString()] ===
      undefined
    ) {
      findAssociatedTokenAddress(wallet.publicKey, mint).then((assocTok) => {
        let walletAccounts = Object.assign(
          {},
          associatedTokensCache[wallet.publicKey.toString()],
        );
        walletAccounts[mint.toString()] = assocTok;
        associatedTokensCache[wallet.publicKey.toString()] = walletAccounts;
        if (assocTok.equals(publicKey)) {
          // Force a rerender now that we've cached the value.
          setForceUpdate((forceUpdate) => !forceUpdate);
        }
      });
    }
  }

  // undefined => not loaded.
  let isAssociatedToken = mint ? undefined : false;
  if (
    wallet &&
    wallet.publicKey &&
    mint &&
    associatedTokensCache[wallet.publicKey.toString()]
  ) {
    let acc =
      associatedTokensCache[wallet.publicKey.toString()][mint.toString()];
    if (acc) {
      if (acc.equals(publicKey)) {
        isAssociatedToken = true;
      } else {
        isAssociatedToken = false;
      }
    }
  }

  const subtitle =
    isExtensionWidth || !publicKey.equals(balanceInfo.owner) ? undefined : (
      <div style={{ display: 'flex', height: '20px', overflow: 'hidden' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          {publicKey.toBase58()}
        </div>
      </div>
    );

  const usdValue =
    price === undefined // Not yet loaded.
      ? undefined
      : price === null // Loaded and empty.
        ? null
        : ((amount / Math.pow(10, decimals)) * price).toFixed(2); // Loaded.
  if (setUsdValue && usdValue !== undefined) {
    setUsdValue(publicKey, usdValue === null ? null : parseFloat(usdValue));
  }
  // console.log("allwallet", allwallet);

  const onclickDeleted = () => {
    alert('clicked')
  }
  // console.log("all accounts", JSON.parse(localStorage.getItem("all_account_key")))
  return (
    <>
      {/* <ListItem button onClick={() => expandable && setOpen((open) => !open)} > */}
      <div>
        {
          JSON.parse(localStorage.getItem("all_account_key")) != null && JSON.parse(localStorage.getItem("all_account_key")).map((item, index) => {
            return (
              <div className="all-wallets">
                <div className="wallet-wrap">
                  <div className="row align-items-center">
                    <div className="col">
                      <h6>{item.walletName}</h6>
                    </div>
                    <div className="col">
                      <ListItemText
                        secondary={item.address}
                        secondaryTypographyProps={{ className: classes.address }}
                      />
                    </div>
                    <div className="col">
                      <div className="row align-items-center">
                        <div className="col">
                          <ListItemText
                            primary={
                              <>
                                {item.wallet_balacne}
                              </>
                            }

                          />
                        </div>
                        <div className="col d-flex justify-content-end align-items-center">
                          <div className="actions">

                            {
                              item.walletName && item.walletName !== 'Main account' && (
                                <Tooltip title="Edit Account Name" arrow>
                                  <IconButton
                                    size={iconSize}
                                    onClick={() => {
                                      setShowEditAccountNameDialog(true);
                                      setIndex(index)
                                    }}
                                  >
                                    <i class="fas fa-pen"></i>
                                  </IconButton>
                                </Tooltip>
                              )
                            }

                            <i class="fas fa-times"
                              onClick={(e) => RemoveAccount(e, index)}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            )
          }
          )
        }
      </div>


      {/* <ListItemIcon>
        <TokenIcon
          mint={mint}
          tokenName={tokenName}
          url={tokenLogoUri}
          size={28}
        />
      </ListItemIcon> */}
      {/* <div style={{ display: 'flex', flex: 1 }}>
        <ListItemText
          primary={
            <>
              {balanceFormat.format(amount / Math.pow(10, decimals))}{' '}
              {displayName}
            </>
          }
          secondary={subtitle}
          secondaryTypographyProps={{ className: classes.address }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          {price && (
            <Typography color="textSecondary">
              {numberFormat.format(usdValue)}
            </Typography>
          )}
        </div>
      </div> */}
      <EditAccountNameDialog
        open={showEditAccountNameDialog}
        onClose={() => setShowEditAccountNameDialog(false)}
        // oldName={selectedAccount ? selectedAccount.name : ''}
        onEdit={(name) => {
          setName(index, name);
          setShowEditAccountNameDialog(false);
        }}
      // indexes={index}
      />
      {/* {expandable ? open ? <ExpandLess /> : <ExpandMore /> : <></>} */}
      {/* </ListItem> */}
      {/* {expandable && ( */}
      {/* <Collapse in={open} timeout="auto" unmountOnExit> */}
      {/* <BalanceListItemDetails
        isAssociatedToken={isAssociatedToken}
        publicKey={publicKey}
        serumMarkets={serumMarkets}
        balanceInfo={balanceInfo}
      /> */}
      {/* </Collapse> */}
      {/* )} */}
    </>
  );
}


function BalanceListItemDetails({
  publicKey,
  serumMarkets,
  balanceInfo,
  isAssociatedToken,
}) {
  const urlSuffix = useSolanaExplorerUrlSuffix();
  const classes = useStyles();
  const [sendDialogOpen, setSendDialogOpen] = useState(false);
  const [depositDialogOpen, setDepositDialogOpen] = useState(false);
  const [tokenInfoDialogOpen, setTokenInfoDialogOpen] = useState(false);
  const [exportAccDialogOpen, setExportAccDialogOpen] = useState(false);
  const [
    closeTokenAccountDialogOpen,
    setCloseTokenAccountDialogOpen,
  ] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const wallet = useWallet();
  const isProdNetwork = useIsProdNetwork();
  const [swapInfo] = useAsyncData(async () => {
    if (!showSwapAddress || !isProdNetwork) {
      return null;
    }
    return await swapApiRequest(
      'POST',
      'swap_to',
      {
        blockchain: 'sol',
        coin: balanceInfo.mint?.toBase58(),
        address: publicKey.toBase58(),
      },
      { ignoreUserErrors: true },
    );
  }, [
    'swapInfo',
    isProdNetwork,
    balanceInfo.mint?.toBase58(),
    publicKey.toBase58(),
  ]);
  const isExtensionWidth = useIsExtensionWidth();

  if (!balanceInfo) {
    return <LoadingIndicator delay={0} />;
  }

  let { mint, tokenName, tokenSymbol, owner, amount } = balanceInfo;

  // Only show the export UI for the native SOL coin.
  const exportNeedsDisplay =
    mint === null && tokenName === 'SOL' && tokenSymbol === 'SOL';

  const market = tokenSymbol
    ? serumMarkets[tokenSymbol.toUpperCase()]
      ? serumMarkets[tokenSymbol.toUpperCase()].publicKey
      : undefined
    : undefined;
  const isSolAddress = publicKey.equals(owner);
  const additionalInfo = isExtensionWidth ? undefined : (
    <>
      <Typography variant="body2">
        Token Name: {tokenName ?? 'Unknown'}
      </Typography>
      <Typography variant="body2">
        Token Symbol: {tokenSymbol ?? 'Unknown'}
      </Typography>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          {!isSolAddress && isAssociatedToken === false && (
            <div style={{ display: 'flex' }}>
              This is an auxiliary token account.
            </div>
          )}
          <Typography variant="body2">
            <Link
              href={
                `https://solscan.io/account/${publicKey.toBase58()}` + urlSuffix
              }
              target="_blank"
              rel="noopener"
            >
              View on Solscan
            </Link>
          </Typography>
          {market && (
            <Typography variant="body2">
              <Link
                href={`https://dex.projectserum.com/#/market/${market}`}
                target="_blank"
                rel="noopener"
              >
                View on Serum
              </Link>
            </Typography>
          )}
          {swapInfo && swapInfo.coin.erc20Contract && (
            <Typography variant="body2">
              <Link
                href={
                  `https://etherscan.io/token/${swapInfo.coin.erc20Contract}` +
                  urlSuffix
                }
                target="_blank"
                rel="noopener"
              >
                View on Ethereum
              </Link>
            </Typography>
          )}
          {!isSolAddress && (
            <Typography variant="body2">
              <Link
                className={classes.viewDetails}
                onClick={() => setShowDetails(!showDetails)}
              >
                View Details
              </Link>
            </Typography>
          )}
          {showDetails &&
            (mint ? (
              <Typography variant="body2" className={classes.address}>
                Mint Address: {mint.toBase58()}
              </Typography>
            ) : null)}
          {!isSolAddress && showDetails && (
            <Typography variant="body2" className={classes.address}>
              {isAssociatedToken ? 'Associated' : ''} Token Metadata:{' '}
              {publicKey.toBase58()}
            </Typography>
          )}
        </div>
        {exportNeedsDisplay && wallet.allowsExport && (
          <div>
            <Typography variant="body2">
              <Link href={'#'} onClick={(e) => setExportAccDialogOpen(true)}>
                Export
              </Link>
            </Typography>
          </div>
        )}
      </div>
    </>
  );

  return (
    <>
      {wallet.allowsExport && (
        <ExportAccountDialog
          onClose={() => setExportAccDialogOpen(false)}
          open={exportAccDialogOpen}
        />
      )}
      <div className={classes.itemDetails}>
        <div className={classes.buttonContainer}>
          {!publicKey.equals(owner) && showTokenInfoDialog ? (
            <Button
              variant="outlined"
              color="default"
              startIcon={<InfoIcon />}
              onClick={() => setTokenInfoDialogOpen(true)}
            >
              Token Info
            </Button>
          ) : null}
          <Button
            variant="outlined"
            color="primary"
            startIcon={<ReceiveIcon />}
            onClick={() => setDepositDialogOpen(true)}
          >
            Receive
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<SendIcon />}
            onClick={() => setSendDialogOpen(true)}
          >
            Send
          </Button>
          {localStorage.getItem('warning-close-account') &&
            mint &&
            amount === 0 ? (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              startIcon={<DeleteIcon />}
              onClick={() => setCloseTokenAccountDialogOpen(true)}
            >
              Delete
            </Button>
          ) : null}
        </div>
        {additionalInfo}
      </div>
      <SendDialog
        open={sendDialogOpen}
        onClose={() => setSendDialogOpen(false)}
        balanceInfo={balanceInfo}
        publicKey={publicKey}
      />
      <DepositDialog
        open={depositDialogOpen}
        onClose={() => setDepositDialogOpen(false)}
        balanceInfo={balanceInfo}
        publicKey={publicKey}
        swapInfo={swapInfo}
        isAssociatedToken={isAssociatedToken}
      />
      <TokenInfoDialog
        open={tokenInfoDialogOpen}
        onClose={() => setTokenInfoDialogOpen(false)}
        balanceInfo={balanceInfo}
        publicKey={publicKey}
      />
      <CloseTokenAccountDialog
        open={closeTokenAccountDialogOpen}
        onClose={() => setCloseTokenAccountDialogOpen(false)}
        balanceInfo={balanceInfo}
        publicKey={publicKey}
      />
    </>
  );
}

